import { Form, Modal, Row, Col, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import numeral from 'numeral';
import { isMobileOnly } from 'react-device-detect';

const { Text } = Typography;

const TotalDifference = ({ visible, onCancel, onCreate, dataOperation }) => {
	const { t } = useTranslation();
	const [form] = Form.useForm();

	const detailOptions = (name, quantity, color, condition) => {
		return (
			<Row
				style={{
					display: 'flex',
					justifyContent: name !== '' && 'space-between',
					marginBottom: 4,
					columnGap: 8,
					marginTop: 4
				}}>
				<div
					className="amounts-name-mortgage"
					style={{
						fontWeight: condition === 'total' ? 600 : 400,
						fontSize: 16,
						color: '#212121'
					}}>
					{t(name)} {name === 'onboarding.totalDifference' && '*'}
				</div>
				<div
					className="amounts-name-mortgage amounts-quantity"
					style={{
						fontWeight: condition === 'total' ? 600 : 400,
						fontSize: 16,
						color: color
					}}>
					{quantity}
				</div>
			</Row>
		);
	};
	const detailOptionsTotal = (name, description, quantity, color, condition) => {
		return (
			<Row
				style={{
					display: 'flex',
					marginBottom: 24,
					alignItems: 'center'
				}}>
				<Col span={15} style={{ display: 'flex', flexDirection: 'column' }}>
					<div
						style={{
							fontWeight: 400,
							color: '#006DFF',
							fontSize: 14
						}}>
						{t(description)}
					</div>
				</Col>

				<Col
					span={9}
					style={{
						fontWeight: condition === 'total' && 600,
						fontSize: 16,
						color: color,
						textAlign: 'right',
						marginTop: visible?.title === 'onboarding.fixedSpread' ? -40 : -40
					}}>
					{quantity}
				</Col>
			</Row>
		);
	};

	const calcuateAll = () => {
		return numeral(Math.abs(visible.savings)).format('0,0.00 $');
	};

	return (
		<Modal
			centered
			zIndex={1200}
			className={
				isMobileOnly
					? 'gb-modal-32-padding ModalCommonSmallDelete modal-onboarding-amount'
					: 'ModalCommon ModalCommonSmallDelete modal-onboarding-amount'
			}
			cancelButtonProps={{
				className: 'button-secundary-gibobs',
				style: { display: 'none' }
			}}
			okButtonProps={{
				className: 'button-primari-gibobs',
				style: { display: 'none' }
			}}
			open={visible}
			title={t('__sabadell-es__onboarding.calculationSavingsModal', {
				type:
					visible?.title === 'onboarding.fixedSpread'
						? t('form.fixedSpread')
						: t('form.variableSpread')
			})}
			okText={t('viability.continue')}
			cancelText={t('mydocuments.deleteCancel')}
			width={600}
			onCancel={() => {
				onCancel();
				form.resetFields();
			}}
			onOk={() => {
				form
					.validateFields()
					.then((values) => {
						onCreate(values);
						form.resetFields();
					})
					.catch((info) => {
						console.log('Validate Failed:', info);
					});
			}}>
			<Row style={{ marginBottom: 24 }}>
				<Col span={15}>
					<Text style={{ color: '#212121', fontSize: 16, fontWeight: 500 }}>
						{t('form.pendingCapital')}
					</Text>
				</Col>
				<Col span={9} style={{ textAlign: 'right' }}>
					<Text style={{ color: '#757575', fontSize: 16, fontWeight: 500 }}>
						{numeral(dataOperation.amount).format('0,0.00 $')}
					</Text>
				</Col>
			</Row>

			{detailOptions(
				'onboarding.quotaGibobs',
				numeral(visible && visible.quote).format('0,0.00 $') + '/' + t('viability.monthsEstimated'),
				'#006DFF'
			)}
			{detailOptions(
				'onboarding.estimatedCurrentQuota',
				numeral(visible && visible.currentQuote).format('0,0.00 $') + '/mes',
				'#757575'
			)}
			<div style={{ border: '1px solid #757575', marginBottom: 4 }}></div>

			{/* Inicio Diferencia en cuotas fijo */}
			<Text style={{ color: '#212121', fontSize: 16, fontWeight: 500 }}>
				{visible?.title !== 'onboarding.fixedSpread'
					? t('subrogation.diferentquote')
					: t('onboarding.differenceInQuota')}
			</Text>
			{visible?.title === 'onboarding.fixedSpread' &&
				detailOptionsTotal(
					'onboarding.differenceInQuota',
					`(${numeral(visible && visible.quote).format('0,0.0 $')} - ${numeral(
						visible && visible.currentQuote
					).format('0,0.0 $')}) x ${visible && visible.pendingTerm ? visible.pendingTerm : 0} ${t(
						'onboarding.quotas'
					).toLowerCase()}`,
					numeral(Math.abs(visible?.monthlySavings) * visible.pendingTerm).format('0,0.00 $') + '*',
					visible && (visible.quote - visible.currentQuote) * visible.pendingTerm < 0
						? '#239D45'
						: '#BE0028',
					'total'
				)}
			{/* Fin Diferencia en cuotas fijo */}

			{/* Inicio Diferencia en cuotas variable */}
			{visible?.title !== 'onboarding.fixedSpread' && (
				<>
					{detailOptionsTotal(
						'onboarding.differenceInQuota',
						`(${numeral(visible && visible.currentQuote).format('0,0.0 $')} - ${numeral(
							visible && visible.quote
						).format('0,0.0 $')}) x ${12} ${t('onboarding.quotas').toLowerCase()}`,
						numeral(visible && Math.abs(visible.currentQuote - visible.quote) * 12).format(
							'0,0.00 $'
						) + '*',
						visible && (visible.currentQuote - visible.quote) * 12 > 0 ? '#239D45' : '#BE0028',
						'total'
					)}

					{detailOptions(
						'onboarding.quotaGibobs',
						numeral(visible && visible.quote1).format('0,0.00 $') +
						'/' +
						t('viability.monthsEstimated'),
						'#006DFF'
					)}
					{detailOptions(
						'onboarding.estimatedCurrentQuota',
						numeral(visible && visible.currentQuote).format('0,0.00 $') + '/mes',
						'#757575'
					)}
					<div style={{ border: '1px solid #757575', marginBottom: 4 }}></div>
					<Text style={{ color: '#212121', fontSize: 16, fontWeight: 500 }}>
						{t('subrogation.diferentquote2')}
					</Text>
					{detailOptionsTotal(
						'onboarding.differenceInQuota',
						`(${numeral(visible && visible.currentQuote).format('0,0.0 $')} - ${numeral(
							visible && visible.quote1
						).format('0,0.0 $')}) x ${visible && visible.pendingTerm ? visible.pendingTerm - 12 : 0
						} ${t('onboarding.quotas').toLowerCase()}`,
						numeral(
							visible &&
							Math.abs(visible.currentQuote - visible.quote1) * (visible.pendingTerm - 12)
						).format('0,0.00 $'),
						visible && (visible.currentQuote - visible.quote1) * (visible.pendingTerm - 12) > 0
							? '#239D45'
							: '#BE0028',
						'total'
					)}
				</>
			)}
			{/* Fin Diferencia en cuotas variable */}

			<div style={{ marginTop: 0 }}>
				{/* Inicio Diferencia en productos asociados variables*/}
				{visible?.title !== 'onboarding.fixedSpread' && (
					<>
						{detailOptions(
							'subrogation.linkSabadel',
							numeral(visible.annualCostLinkages).format('0,0.00 $') + '/' + t('common.year'),
							'#006DFF'
						)}
						{detailOptions(
							'subrogation.linkAmount',
							numeral(visible.costOtherProducts).format('0,0.00 $') + '/' + t('common.year'),
							'#757575'
						)}
						<div style={{ border: '1px solid #757575', marginBottom: 4 }}></div>

						<Text style={{ color: '#212121', fontSize: 16, fontWeight: 500 }}>
							{t('onboarding.differenceInLinkages')}
						</Text>

						{detailOptionsTotal(
							'onboarding.differenceInQuota',
							`(${visible.costOtherProducts} - ${visible.annualCostLinkages}) x ${numeral(
								visible.pendingTerm / 12
							).format('0,0')} años pendientes`,
							numeral(
								Math.abs(
									(visible.costOtherProducts - visible.annualCostLinkages) *
									numeral(visible.pendingTerm / 12).format('0,0')
								)
							).format('0,0.00 $') + '*',
							visible &&
								((visible.costOtherProducts - visible.annualCostLinkages) * visible.pendingTerm) /
								12 >
								0
								? '#239D45'
								: '#BE0028',
							'total'
						)}
					</>
				)}
				{/* Fin Diferencia en productos asociados variable*/}

				{/* Inicio Diferencia en productos asociados fijos*/}
				{visible?.title === 'onboarding.fixedSpread' && (
					<>
						{detailOptions(
							'onboarding.linksWithGibobs',
							numeral(visible?.annualCostLinkages ?? 0).format('0,0.00 $') + '/' + t('common.year'),
							'#006DFF'
						)}
						{detailOptions(
							'onboarding.currentLinkages',
							numeral(
								dataOperation?.costOtherProducts ? dataOperation.costOtherProducts : 0
							).format('0,0.00 $') +
							'/' +
							t('common.year'),
							'#757575'
						)}
						<div style={{ border: '1px solid #757575', marginBottom: 4 }}></div>
						<Text style={{ color: '#212121', fontSize: 16, fontWeight: 500 }}>
							{t('onboarding.differenceInLinkages')}
						</Text>
						{detailOptionsTotal(
							'onboarding.differenceInLinkages',
							`(${numeral(visible?.annualCostLinkages ?? 0).format('0,0.00 $')} - ${numeral(
								dataOperation && dataOperation.costOtherProducts
									? dataOperation.costOtherProducts
									: 0
							).format('0,0.00 $')}) x ${visible && visible.pendingTerm
								? numeral(visible.pendingTerm / 12).format('0,0.00')
								: 0
							} ${t('onboarding.yearsPending')}`,
							numeral(
								Math.abs(
									((visible?.annualCostLinkages ?? 0) -
										(dataOperation && dataOperation.costOtherProducts
											? dataOperation.costOtherProducts
											: 0)) *
									(visible && visible.pendingTerm ? visible.pendingTerm / 12 : 0)
								)
							).format('0,0.00 $'),
							((visible?.annualCostLinkages ?? 0) -
								(dataOperation && dataOperation.costOtherProducts
									? dataOperation.costOtherProducts
									: 0)) *
								(visible && visible.pendingTerm ? visible.pendingTerm / 12 : 0) >
								0
								? '#BE0028'
								: '#239D45',
							'total'
						)}
					</>
				)}

				{visible?.title !== 'onboarding.fixedSpread' && (
					<div style={{ marginTop: 24 }}>
						{detailOptions(
							'onboarding.totalDifference',
							calcuateAll(),
							visible.savings < 0 ? '#BE0028' : '#239D45',
							'total'
						)}
					</div>
				)}

				{/* Fin Diferencia en productos asociados fijos*/}
				{visible?.title === 'onboarding.fixedSpread' && (
					<div style={{ marginTop: 24 }}>
						{detailOptions(
							'onboarding.totalDifference',
							numeral(Math.abs(visible?.savings)).format('0,0.00 $'),
							visible &&
								(visible.quote - visible.currentQuote) * visible.pendingTerm +
								((visible?.annualCostLinkages ?? 0) -
									(dataOperation && dataOperation.costOtherProducts
										? dataOperation.costOtherProducts
										: 0)) *
								(visible && visible.pendingTerm ? visible.pendingTerm / 12 : 0) >
								0
								? '#BE0028'
								: '#239D45',
							'total'
						)}
					</div>
				)}
				<div className="description-viability" style={{ fontSize: 12 }}>
					{t('onboarding.excludingCancellation')}
				</div>
			</div>
		</Modal>
	);
};

export default TotalDifference;
